import * as React from 'react'

interface State {
  hasError: boolean
}

export class ErrorBoundary extends React.Component<Props, State> {
  state = {
    hasError: false,
  }

  componentDidCatch() {
    this.setState({ hasError: true })
  }

  render() {
    if (this.state.hasError) {
      return (
        <h1>
          Ha tenido lugar un error no previsto. Por favor, ponte en contacto con nosotros para que podamos resolverlo
        </h1>
      )
    }
    return this.props.children
  }
}



// WEBPACK FOOTER //
// ./src/views/components/ErrorBoundary.tsx